// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
//import ThemeProvider from "../src/helper/themesk"

// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './xx_minimalUi_old/snackbar';
import { ThemeSettings } from './xx_minimalUi_old/settings';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { oktaAuthConfig } from 'config';
import { Security } from '@okta/okta-react';
import { useNavigate } from 'react-router';
import { ToastContainer } from 'react-toastify';

var url = new URL(window.location.href);
var c = url.searchParams.get('access_token');
if (c !== null) {
  localStorage.setItem('access_token', c);
}

const oktaAuth = new OktaAuth(oktaAuthConfig);

export default function App() {
  const navigate = useNavigate();

  // ----------------------------------------------------------------------
  const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  const triggerLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const customAuthHandler = async () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      // App initialization stage
      await triggerLogin();
    }
  };

  return (
    <ThemeProvider>
      <ThemeSettings>
        <ThemeLocalization>
          <SnackbarProvider>
            <Security
              oktaAuth={oktaAuth}
              onAuthRequired={customAuthHandler}
              restoreOriginalUri={restoreOriginalUri}
            >
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                style={{}}
              />
              <Router />
            </Security>
          </SnackbarProvider>
        </ThemeLocalization>
      </ThemeSettings>
    </ThemeProvider>
  );
}
